import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import { widthRange } from '../../shared/constants';
import { media } from '../../shared/styles/constants';
import {constants} from '../constants';

const cssMediaItemSettingsLeft = {
	desktop: { item: { width: '560px' }},
	laptop: { item: { width: '460px' }},
	tablet: { item: { width: '347px' }},
	mobile: {
		item: { width: '100%' },
		itemMeta: {
			marginLeft: '10px',
			marginRight: '10px'
		}
	}
};

const cssMediaItemSettingsMiddle = {
	desktop: { item: { width: '560px' }},
	laptop: { item: { width: '460px' }},
	tablet: { item: { width: '347px' }},
	mobile: {
		item: { width: '100%' },
		itemMeta: {
			marginLeft: '10px',
			marginRight: '10px'
		}
	}
};

const cssMediaItemSettingsRight = {
	desktop: { item: { width: '260px' }},
	laptop: { item: { width: '300px' }},
	tablet: { item: { width: '223px' }},
	mobile: { item: { width: '46%' }}
};

class SevenItems extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			leftContainerPosts: this.props.posts.slice(0, 2),
			middleContainerPosts: this.props.posts.slice(2, 3),
			rightContainerPosts: this.props.posts.slice(3, 7),
			currentWidthRange: widthRange.DESKTOP
		}
	}

	organizeContainers(){
		if (!window) {
			return;
		}

		let width = window.innerWidth;

		if (width >= 1280) {
			if (this.state.currentWidthRange === widthRange.DESKTOP) {
				return;
			}

			this.setState(() => ({
				leftContainerPosts: this.props.posts.slice(0, 2),
				middleContainerPosts: this.props.posts.slice(2, 3),
				rightContainerPosts: this.props.posts.slice(3, 7),
				currentWidthRange: widthRange.DESKTOP
			}));

			return;
		}

		if (width >= 768) {
			if (this.state.currentWidthRange === widthRange.TABLET_LAPTOP) {
				return;
			}

			this.setState(() => ({
				leftContainerPosts: this.props.posts.slice(0, 4),
				middleContainerPosts: [],
				rightContainerPosts: this.props.posts.slice(4, 7),
				currentWidthRange: widthRange.TABLET_LAPTOP
			}));

			return;
		}

		if (this.state.currentWidthRange === widthRange.MOBILE) {
			return;
		}

		this.setState(() => ({
			leftContainerPosts: this.props.posts.slice(0, 1),
			middleContainerPosts: [],
			rightContainerPosts: this.props.posts.slice(1, 7),
			currentWidthRange: widthRange.MOBILE
		}));
	}

	componentDidMount() {
		this.organizeContainers();

		if (window){
			window.addEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	componentWillUnmount() {
		if (window){
			window.removeEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	render() {
		const leftPosts = this.state.leftContainerPosts;
		const middlePosts = this.state.middleContainerPosts;
		const rightPosts = this.state.rightContainerPosts;
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				<div className={css(styles.container)}>
					{leftPosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsLeft} outerIndex={outerIndex++} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
				<div className={css(styles.container, styles.containerHalfWidth )}>
					{middlePosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsMiddle} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
				<div className={css(styles.container, styles.containerHalfWidth)}>
					{rightPosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsRight} outerIndex={outerIndex++} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
			</div>
		);
	}
}

export default SevenItems;

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		width: '100%',

		[media.LAPTOP]: {
			width: '100%'
		},

		[media.TABLET]: {
			width: '100%'
		},

		[media.MOBILE]: {
			width: '100%',
			justifyContent: 'space-around'
		}
	},
	containerHalfWidth: {
		[media.DESKTOP]: {
			width: '560px'
		}
	}
});



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/SevenItems.js